export default __webpack_public_path__ + "static/media/panTech2.6110b135.png";